import { useState } from 'react'
import { Stack } from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import { SUCCEEDED } from 'utils/constants'

import { CreateComment } from './CreateComment'
import { CommentsList } from './CommentsList'

export const Comments = ({
  eventComments,
  eventData,
  getEventCommentsStatus,
  GoToMarker
}) => {
  const [editCommentData, setEditCommentData] = useState({})

  return (
    <Stack
      key={eventData?.id}
      padding="10px 5px 10px 5px"
      background={COLORS.darkGray}
      minHeight="100%"
    >
      {
        getEventCommentsStatus === SUCCEEDED || eventComments?.length
          ? (
            <CreateComment
              editCommentData={editCommentData}
              setEditCommentData={setEditCommentData}
            />
          ) : ''
      }

      <CommentsList
        GoToMarker={GoToMarker}
        setEditCommentData={setEditCommentData}
      />
    </Stack>
  )
}
